import { z } from 'zod';

export const formSchema = z.object({
  username: z.string().trim().min(1, { message: 'username / password required' }),
  password: z.string().trim().min(1, { message: 'Password required' })
});

export type FormSchema = typeof formSchema;
